<script>
import { mapActions } from "vuex";

export default {
  props: {
    opened: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      title: "",
      message: "",
      loader: false
    };
  },

  methods: {
    ...mapActions("professionalRegisterFlow", ["sendNotification"]),

    closeDialog() {
      this.$emit("close");
    },

    setTitle(title) {
      this.title = title;
    },

    setMessage(message) {
      this.message = message;
    },

    clearState() {
      this.title = "";
      this.message = "";
    },

    buildNotification() {
      return {
        title: this.title,
        message: this.message,
        account_status: [],
        accountable_status: [this.status],
        states: [],
        cities: [],
        districts: [],
        users: [],
        user_type: "professionals"
      };
    },

    sendProfessionalNotification() {
      this.sendNotification(this.buildNotification());

      this.clearState();

      this.closeDialog();
    }
  }
};
</script>

<template>
  <v-dialog v-model="opened" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span>
          Enviar notificações para os profissionais na fase:
          <i>{{ name.toLowerCase() }}</i>
        </span>

        <v-spacer></v-spacer>

        <v-btn color="accent" rounded icon outlined @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-text-field
          required
          name="title"
          label="título"
          data-vv-as="título"
          prepend-inner-icon="mdi-format-title"
          v-validate="'required|max:100'"
          :counter="100"
          :value="title"
          :error="errors.has('title')"
          :error-messages="errors.first('title')"
          @input="setTitle"
        />

        <v-textarea
          required
          auto-grow
          rows="3"
          name="message"
          label="mensagem"
          prepend-inner-icon="mdi-subtitles-outline"
          v-validate="'required|max:250'"
          :counter="250"
          :value="message"
          :error="errors.has('message')"
          :error-messages="errors.first('message')"
          @input="setMessage"
        />
      </v-card-text>

      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          rounded
          :loading="loader"
          @click="sendProfessionalNotification"
        >
          enviar notificação
          <v-icon right small>send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
span {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalRegisterFlow/components/Notification.vue